import React, {
  useState,
  useCallback,
  useContext,
  useMemo,
  useEffect,
} from "react";
import ItemLibrary from "../ItemLibrary/ItemLibrary";
import ModalDetail from "../ModalDetail/ModalDetail";
import { AuthenticationContext } from "../AuthenticationContextProvider";
import { LocaleContext } from "../../components/LocaleContextProvider";
import { ConfigContext } from "../../components/ConfigContextProvider";

// Modal.defaultStyles.overlay.backgroundColor = 'black';
// Modal.defaultStyles.overlay.zIndex = 20;

const Library = (props) => {
  //const {items, currentSelected} = props;
  //const [items, setItems] = useState(props.items);
  const { userOptions } = useContext(AuthenticationContext);
  const { locale } = useContext(LocaleContext);
  const { PRODUCTS_URL } = useContext(ConfigContext);
  const isLoggedIn = userOptions && Number(userOptions.login);
  const { dataList } = props;

  const [detail, setDetail] = useState(null);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [products, setProducts] = useState(null);

  const afterOpenModal = useCallback(() => {
    setIsOpen(true);
  });

  const openModal = useCallback(() => {
    setIsOpen(true);
  });

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setDetail(null);
  });

  //const {items, currentSelected} = props;
  const openDetailHandler = useCallback((detail) => {
    setDetail(detail);
    setIsOpen(true);
  });

  //useffect
  const loadGallery = (item) => {
    if (!item) return;
    fetch(`${PRODUCTS_URL}${item.query}_${locale}.json`)
      .then((res) => res.json())
      .then(
        (result) => {
          setProducts(result);
          //setUserOptions(result.settings)
        },
        (error) => {
          setProducts([]);
        }
      );
  };

  useEffect(() => {
    let selection = props.order || props.category || props.type;
    loadGallery(selection);
  }, []);

  return (
    <>
      {!isLoggedIn && (
        <div id="login-required-description" style={{ position: 'absolute', left: '-10000px' }}>
          Login required to download this file
        </div>
      )}
      <div className="library__wrapper">
        <div className="library__container">
          <>
            {products &&
              products.sorting &&
              products.sorting.map((group, g) => {
                return (
                  <div className="groupLibrary" key={"group" + g}>
                    <h3 className="groupLibrary__name">{group.name}</h3>
                    <ul className="libraryList">
                      {group.items.map((item, i) => {
                        return (
                          <ItemLibrary
                            key={group.name + "" + g + "_" + i}
                            item={item}
                            onClick={openDetailHandler}
                          />
                        );
                      })}
                    </ul>
                  </div>
                );
              })}

            <ul className="libraryList">
              {products &&
                products.items &&
                products.items.map((item, i) => {
                  return (
                    <ItemLibrary
                      key={item.name + "_" + i}
                      item={item}
                      onClick={openDetailHandler}
                    />
                  );
                })}
            </ul>
          </>
        </div>
      </div>

      {detail && (
        <ModalDetail
          detail={detail}
          modalIsOpen={modalIsOpen}
          closeModal={closeModal}
        />
      )}
    </>
  );
};

export default Library;
